// Reconstructed from production code; original paths and local names were not available.
import { AdminSidebar } from "../components/AdminSidebar.jsx";
import { Navigate } from "react-router-dom";
import { Outlet } from "react-router-dom";
import React from "react";
import { Seo } from "../components/Seo.jsx";
import * as jsxRuntime from "react/jsx-runtime";
import { useAuth } from "../context/AuthContext.jsx";
import { useLanguage } from "../context/LanguageContext.jsx";
import { useLocation } from "react-router-dom";
import { useTheme } from "../context/ThemeContext.jsx";
function AdminMenuIcon() {
  return (
    <svg
      viewBox={"0 0 24 24"}
      fill={"none"}
      stroke={"currentColor"}
      strokeWidth={"1.9"}
      strokeLinecap={"round"}
      aria-hidden={"true"}
    >
      <path d={"M4 7h16M4 12h16M4 17h16"} />
    </svg>
  );
}
const adminPageHeading = (l, i, c) => {
  const s = c === "ar",
    d = [
      {
        match: "/admin/dashboard",
        title: i("adminDashboard"),
        subtitle: s
          ? "الإيرادات والطلب وأداء المنتجات."
          : "Revenue, demand and product performance.",
      },
      {
        match: "/admin/visitors",
        title: i("adminVisits"),
        subtitle: s
          ? "إحصاءات الزيارات وتوقيتها داخل المتجر."
          : "Store visit activity and timing.",
      },
      {
        match: "/admin/products",
        title: i("adminProducts"),
        subtitle: s
          ? "الكتالوج، الأسعار، الصور والمتغيرات."
          : "Catalogue, prices, images and variants.",
      },
      {
        match: "/admin/caisse",
        title: i("adminCaisse"),
        subtitle: s
          ? "المسح، البيع والفوترة المباشرة."
          : "Scan, sale and direct billing.",
      },
      {
        match: "/admin/categories",
        title: i("adminCategories"),
        subtitle: s
          ? "العائلات، الفئات الفرعية والمرئيات."
          : "Families, subcategories and visuals.",
      },
      {
        match: "/admin/commandes",
        title: i("adminCommandes"),
        subtitle: s
          ? "المتابعة، التحقق والفواتير."
          : "Tracking, validation and invoices.",
      },
      {
        match: "/admin/clients",
        title: i("adminClients"),
        subtitle: s
          ? "الحسابات، الحالة والوصول."
          : "Accounts, status and access.",
      },
      {
        match: "/admin/users",
        title: i("adminUsers"),
        subtitle: s ? "حسابات المشرفين والصندوق." : "Admin and POS accounts.",
      },
      {
        match: "/admin/partners",
        title: i("adminPartners"),
        subtitle: s
          ? "الشعارات والعلامات التجارية المرتبطة."
          : "Logos and associated brands.",
      },
      {
        match: "/admin/appearance",
        title: i("adminAppearance"),
        subtitle: s
          ? "الهوية البصرية والترحيب."
          : "Visual identity and home layout.",
      },
      {
        match: "/admin/footer",
        title: i("adminFooter"),
        subtitle: s
          ? "الأعمدة، الشبكات والموقع الجغرافي."
          : "Columns, networks and location.",
      },
    ];
  return l === "/admin"
    ? {
        title: i("adminDashboard"),
        subtitle: s
          ? "الإيرادات والطلب وأداء المنتجات."
          : "Revenue, demand and product performance.",
      }
    : d.find((f) => l.startsWith(f.match)) || {
        title: i("adminTitle"),
        subtitle: s ? "مركز التحكم" : "Control center",
      };
};
function AdminLayout() {
  const { user: user } = useAuth(),
    i = useLocation(),
    { theme: theme } = useTheme(),
    { t: t, language: language, setLanguage: setLanguage, tText } = useLanguage(),
    m = theme?.site_name || "MyShop",
    y = adminPageHeading(i.pathname, t, language),
    [g, p] = React.useState(false),
    b = React.useRef(null),
    x = language === "ar",
    O = React.useCallback(() => {
      p(false);
      window.requestAnimationFrame(() => b.current?.focus());
    }, []);
  React.useEffect(() => {
    if (!g) return;
    const H = (E) => {
      if (E.key === "Escape") {
        O();
        return;
      }
      if (E.key !== "Tab") return;
      const M = Array.from(
          document.querySelectorAll(
            "#admin-mobile-navigation button:not([disabled]), #admin-mobile-navigation a[href]",
          ),
        ),
        N = M[0],
        T = M.at(-1);
      !N ||
        !T ||
        (E.shiftKey && document.activeElement === N
          ? (E.preventDefault(), T.focus())
          : !E.shiftKey &&
            document.activeElement === T &&
            (E.preventDefault(), N.focus()));
    };
    document.body.classList.add("admin-nav-open");
    window.addEventListener("keydown", H);
    document
      .querySelector("#admin-mobile-navigation .admin-sidebar-close")
      ?.focus();
    return () => {
      document.body.classList.remove("admin-nav-open");
      window.removeEventListener("keydown", H);
    };
  }, [O, g]);
  return user?.role === "CAISSE" && i.pathname !== "/admin/caisse" ? (
    <Navigate to={"/admin/caisse"} replace={true} />
  ) : (
    <div className={"admin-shell"}>
      <Seo
        title={tText("Admin")}
        description={tText("Administration area")}
        urlPath={i.pathname}
        type={"website"}
        siteName={m}
        noindex={true}
      />
      <button
        type={"button"}
        className={"admin-sidebar-backdrop" + (g ? " is-visible" : "")}
        aria-label={x ? "إغلاق القائمة" : "Close navigation"}
        onClick={O}
      />
      <AdminSidebar isMobileOpen={g} onClose={O} onNavigate={O} />
      <div className={"admin-main"}>
        <header className={"admin-topbar"}>
          <div className={"admin-topbar-heading"}>
            <button
              type={"button"}
              className={"admin-mobile-menu-trigger"}
              ref={b}
              aria-label={x ? "فتح القائمة" : "Open navigation"}
              aria-controls={"admin-mobile-navigation"}
              aria-expanded={g}
              onClick={() => p((H) => !H)}
            >
              <AdminMenuIcon />
            </button>
            <div className={"admin-topbar-copy"}>
              <p className={"admin-topbar-kicker"}>{m}</p>
              <p className={"admin-topbar-title"}>{y.title}</p>
              <p className={"admin-topbar-subtitle"}>{y.subtitle}</p>
            </div>
          </div>
          <div className={"admin-topbar-actions"}>
            <button
              type={"button"}
              className={"admin-lang-toggle-btn"}
              onClick={() => setLanguage(language === "ar" ? "en" : "ar")}
            >
              {language === "ar" ? "English" : "العربية"}
            </button>
            <a href={"/"} className={"admin-store-link"}>
              {x ? "عرض الموقع" : "View site"}
            </a>
            {user && (
              <div className={"admin-user-chip"}>
                <span className={"admin-user-avatar"}>
                  {user.name?.charAt(0)?.toUpperCase() || "A"}
                </span>
                <div>
                  <div className={"admin-user-name"}>{user.name}</div>
                  <div className={"admin-user-role"}>
                    {user.role === "CAISSE"
                      ? x
                        ? "صندوق"
                        : tText("Point of sale")
                      : x
                        ? "مشرف"
                        : tText("Admin")}
                  </div>
                </div>
              </div>
            )}
          </div>
        </header>
        <div className={"admin-content"}>
          <Outlet />
        </div>
      </div>
    </div>
  );
}
export { AdminMenuIcon, adminPageHeading, AdminLayout };
